module.exports = __webpack_public_path__ + "static/img/logo.c896718c.png";